import { Button } from 'component/Button'
import { SearchInput } from 'component/Input/SearchInput'
import { Scroll } from 'component/Scroll'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { BrandCheckbox } from 'page/StartScreen/combine/brand/BrandCheckbox'
import { Fragment } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { map } from 'util/iterable'
import { isLetter } from 'util/string'

export const BrandStep = observer(() => {
  const item = store.item!
  const { brand, brands_filtered } = item.rec
  let letter_current = ''

  const onSearch = useLatestCallback((value: string) => {
    brand.search = value
  })

  const onRemove = useLatestCallback((value: string) => {
    brand.toggle(value)
  })

  const onReset = useLatestCallback(() => {
    brand.clear()
  })

  return <Vertical gap={24} tall>
    {!opt.stand && <SearchInput large value={brand.search}
      onChange={onSearch} placeholder={i18n('SearchByBrand')} />}

    <Vertical oh margin={[0, -12]}>
      <Scroll>
        <Vertical gap={24} pad={[0, 12]}>
          {!!brand.selection.size && <Space gap={8} wrap>
            {map(brand.selection, brand => <Fragment key={brand}>
              <Button gap={4} primary onClick={() => onRemove(brand)}>
                <Typo size={13} upper>
                  {brand}
                </Typo>
                <Icon size={16} name="close" />
              </Button>
            </Fragment>)}
            <Button link onClick={() => onReset()}>
              {i18n('Reset')}
            </Button>
          </Space>}

          <Vertical>
            {!brands_filtered.length && <Space height={200} center>
              <Typo size={13} upper secondary>
                {i18n('NothingFound')}
              </Typo>
            </Space>}
            {brands_filtered.map((brand, i) => {
              let letter = brand?.title[0] || ''
              if (!isLetter(letter)) letter = ''
              const changed = letter !== letter_current
              letter_current = letter
              const title = changed && !!letter

              return <Fragment key={brand.name}>
                {i > 0 && <Divider tertiary />}
                {title && i > 0 && <Space height={24} />}
                {title && <Space minHeight={24}>
                  <Typo size={15} accent upper primary>
                    {letter}
                  </Typo>
                </Space>}
                <BrandCheckbox brand={brand} />
              </Fragment>
            })}
          </Vertical>
        </Vertical>
      </Scroll>
    </Vertical>
  </Vertical>
})
